var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "tagInput",
      class: [
        "tag-input",
        (!_vm.value || !_vm.value.length) && _vm.isClickOne && !_vm.focusBorder
          ? "isEmpty"
          : "",
        { disabled: _vm.disabled, focusBorder: _vm.focusBorder },
      ],
      on: { click: _vm.clickInput },
    },
    [
      _c("div", { staticClass: "err-empty" }, [
        _vm._v(
          _vm._s(
            _vm.placeholder == "请选择" ? "请选择查询条件" : "请输入查询条件"
          )
        ),
      ]),
      _c(
        "div",
        { ref: "tag", staticClass: "tag" },
        [
          _vm._l(_vm.value, function (item, index) {
            return _c(
              "span",
              {
                key: index,
                staticClass: "textOverflow",
                attrs: { title: item.label },
              },
              [
                _vm._v(" " + _vm._s(item.label) + " "),
                !_vm.disabled
                  ? _c("i", {
                      staticClass: "el-icon-close",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.clickRemove(index)
                        },
                      },
                    })
                  : _vm._e(),
              ]
            )
          }),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.word,
                expression: "word",
              },
            ],
            staticClass: "t-input",
            attrs: {
              disabled: _vm.disabled,
              placeholder: _vm.value.length ? "" : _vm.placeholder,
            },
            domProps: { value: _vm.word },
            on: {
              keydown: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.clickEnter.apply(null, arguments)
              },
              keyup: function ($event) {
                if (!$event.type.indexOf("key") && $event.keyCode !== 186) {
                  return null
                }
                return _vm.clickEnter.apply(null, arguments)
              },
              input: [
                function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.word = $event.target.value
                },
                _vm.change,
              ],
              focus: _vm.getFocus,
              blur: _vm.getBlur,
            },
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }